import React from "react";
import FaFacebookF from "../../assets/icons/facebook";
import FaInstagram from "../../assets/icons/instagram";
import FaYoutube from "../../assets/icons/youtube";
import BsTwitterX from "../../assets/icons/twitter";
import FaTelegramPlane from "../../assets/icons/telegram";
import IoLogoWhatsapp from "../../assets/icons/whatsapp";
import { socialHandles } from "../../utils/constants";

export function InstagramHandle() {
  return (
    <a
      href={socialHandles.instagram}
      target="_blank"
      rel="noreferrer"
      className="homeSocialIcon"
      aria-label="Instagram">
      <FaInstagram />
    </a>
  );
}

export function FacebookHandle() {
  return (
    <a
      href={socialHandles.facebook}
      target="_blank"
      rel="noreferrer"
      className="homeSocialIcon"
      aria-label="Facebook">
      <FaFacebookF />
    </a>
  );
}

export function YoutubeHandle() {
  return (
    <a
      href={socialHandles.youtube}
      target="_blank"
      rel="noreferrer"
      className="homeSocialIcon"
      aria-label="Youtube">
      <FaYoutube />
    </a>
  );
}

export function TelegramHandle() {
  return (
    <a
      href={socialHandles.telegram}
      target="_blank"
      rel="noreferrer"
      className="homeSocialIcon"
      aria-label="Telegram">
      <FaTelegramPlane />
    </a>
  );
}

export function WhatsappHandle() {
  return (
    <a
      href={socialHandles.whatsapp}
      target="_blank"
      rel="noreferrer"
      className="homeSocialIcon"
      aria-label="Whatsapp">
      <IoLogoWhatsapp />
    </a>
  );
}

export function TwitterHandle() {
  return (
    <a
      href={socialHandles.twitter}
      target="_blank"
      rel="noreferrer"
      className="homeSocialIcon"
      aria-label="Twitter">
      <BsTwitterX className="icon-small" />
    </a>
  );
}
